import { PhoneInputValue } from "../PhoneInput";

export const inputValueToPhoneString = (value: PhoneInputValue) =>
  `${value.code}${value.phone}`;
